import { Link } from "react-router-dom";

type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mb-5">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-2">
            {index > 0 ? <i className="ri-arrow-right-s-line w-3.5 h-3.5 flex items-center justify-center"></i> : null}
            {item.to ? (
              <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}